module.exports = __webpack_public_path__ + "fonts/273c2f39cf3c39891a885958c65e31fa.ttf";